import { Component, Input } from '@angular/core';
import { FoundationProject } from '@models';

@Component({
  selector: 'lfx-dev-analytics-project-card',
  templateUrl: './dev-analytics-project-card.component.html',
  styleUrls: ['./dev-analytics-project-card.component.scss'],
})
export class DevAnalyticsProjectCardComponent {
  @Input() project: FoundationProject;
  showOverlayOnProjectCard = false;
  linechartOption = 'all';

  constructor() {}

  onHoverStatistics(option) {
    this.linechartOption = option;
  }
}
